import React from "react";
import { ChevronLeft, ChevronRight, Pause, Play, Repeat, Maximize2 } from "lucide-react";

const toggleFullscreen = () => {
  if (document.fullscreenElement) document.exitFullscreen?.();
  else document.documentElement.requestFullscreen?.().catch(() => {});
};

export const NarrationBar = ({ steps, step, playing, auto, onToggle, onAuto, onPrev, onNext }) => (
  <div className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-[#0B1437]/95 text-white backdrop-blur-xl" data-testid="player-narration-bar">
    <div className="mx-auto flex max-w-6xl flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:gap-5 sm:px-6">
      <div className="flex items-center gap-2">
        <IconBtn onClick={onPrev} disabled={step === 0} label="Paso anterior" testId="player-prev-btn"><ChevronLeft className="h-4 w-4" /></IconBtn>
        <button
          onClick={onToggle}
          className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-blue text-white transition-transform hover:scale-105"
          aria-label={playing ? "Pausar narración" : "Escuchar narración"}
          data-testid="player-play-btn"
        >
          {playing ? <Pause className="h-4 w-4" /> : <Play className="ml-0.5 h-4 w-4" />}
        </button>
        <IconBtn onClick={onNext} disabled={!auto && step === steps.length - 1} label="Paso siguiente" testId="player-next-btn"><ChevronRight className="h-4 w-4" /></IconBtn>
      </div>
      <p className="line-clamp-2 flex-1 text-xs leading-relaxed text-slate-300 sm:text-sm" data-testid="player-subtitle">
        {steps[step]?.narration}
      </p>
      <div className="flex items-center gap-2">
        <button
          onClick={onAuto}
          className={`inline-flex items-center gap-1.5 border px-3 py-2 text-[10px] uppercase tracking-[0.18em] transition-colors ${
            auto ? "border-accent-blue bg-accent-blue text-white" : "border-white/25 text-slate-200 hover:bg-white/10"
          }`}
          data-testid="player-auto-btn"
          aria-pressed={auto}
        >
          <Repeat className="h-3 w-3" /> {auto ? "Automático activo" : "Reproducción automática"}
        </button>
        <IconBtn onClick={toggleFullscreen} label="Pantalla completa" testId="player-fullscreen-btn"><Maximize2 className="h-3.5 w-3.5" /></IconBtn>
      </div>
    </div>
  </div>
);

const IconBtn = ({ onClick, disabled, label, testId, children }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    aria-label={label}
    title={label}
    className="flex h-9 w-9 items-center justify-center border border-white/20 text-slate-200 transition-colors hover:bg-white/10 disabled:opacity-30"
    data-testid={testId}
  >
    {children}
  </button>
);
